import type { SchemaDatasetFile } from "@/entities/schema";
import type { UploadFileType } from "@/modules/upload-file";

import { isAuthorizedUploadFileType } from "@/modules/upload-file";

export const getSchemaAuthorizedUploadFileTypes = (
  template?: SchemaDatasetFile
): UploadFileType[] => {
  return (template?.fileTypeTags ?? [])
    .map((tag) => (isAuthorizedUploadFileType(tag.text) ? tag.text : undefined))
    .filter((fileType) => !!fileType);
};
